/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useProjectSharesCacheInvalidator } from './use-project-shares';

/**
 * Add project share.
 */

function addProjectShare(
  client: AxiosInstance,
  projectId: string,
  payload: { email: string; role: string }
): Promise<any> {
  return client
    .post(resolveAppUrl('projectShares', { interpolations: { projectId } }), payload)
    .then(({ data }) => data);
}

/**
 * Export `useAddProjectShare`.
 */

export function useAddProjectShare(projectId: string) {
  const client = useRequestProvider();
  const invalidator = useProjectSharesCacheInvalidator(projectId);

  return useMutation({
    mutationFn: async (payload: { email: string; role: string }) => {
      const result = await addProjectShare(client, projectId, payload);

      await invalidator();

      return result;
    }
  });
}
